import PropTypes from "prop-types";
import React from "react";
import Button from "../../ui/Button";

const ActionPopup = (props = {}) => {
    const {
        text = "",
        handleCancel,
        handleAction,
        handleActionText = "Ok",
        handleCancelText = "Cancel"
    } = props;
    return (
        <div className="userprofile">
            <div className="logout-popup lg">
                <div className="logout-label">
                    <h5>You're already in a call</h5>
                    <label>{text}</label>
                </div>
                <div className="logout-noteinfo">
                    <Button
                        variant="ghost"
                        type="button"
                        name="btn-cancel"
                        className="btn-cancel"
                        onClick={handleCancel}>
                        {handleCancelText}
                    </Button>
                    <Button
                        variant="primary"
                        type="button"
                        name="btn-logout"
                        className="btn-logout"
                        onClick={handleAction}>
                        {handleActionText}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ActionPopup;

ActionPopup.propTypes = {
    text: PropTypes.string,
    handleCancel: PropTypes.func,
    handleAction: PropTypes.func,
    handleActionText: PropTypes.string,
    handleCancelText: PropTypes.string
};